import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { cloneDeep } from 'lodash'
import integrationUser from 'src/components/Users/IntegrationUser';
import integration from 'src/mixins/integration';
import User from 'src/store/models/User';
import Notify from 'quasar/src/plugins/Notify.js';;
export default {
  mixins: [integration],
  name: 'ListableUsersFromIntegration',
  components: {
    integrationUser: integrationUser
  },
  props: {
    excludedUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    provider: {
      type: String,
      default: ''
    },
    dialog: {
      type: Boolean,
      default: false
    },
    onComplete: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      users: [],
      // selectedUsers: [],
      textFilter: '',
      nextLink: null,
      serverSidePagination: false,
      selectedUsersVisible: false
    };
  },
  computed: {
    allSelected: {
      get: function get() {
        return this.selectableUsers.length === this.selectedUsers.length && this.selectedUsers.length > 0;
      },
      set: function set(val) {
        var _this = this;

        if (val) {
          this.selectableUsers.forEach(function (user) {
            if (_this.selectedUsers.includes(user)) {
              return;
            }

            _this.toggleUserSelected(user);
          });
        } else {
          // this.selectedUsers = []
          this.selectableUsers.forEach(function (user) {
            if (!_this.selectedUsers.includes(user)) {
              return;
            }

            _this.toggleUserSelected(user);
          });
        }
      }
    },
    selectableUsers: function selectableUsers() {
      return this.listableUsers.filter(function (user) {
        return !(user.isMember || user.isRegistered);
      });
    },
    listableUsers: function listableUsers() {
      if (this.serverSidePagination) {
        return this.users;
      } else {
        return this.filteredUsers;
      }
    },
    filteredUsers: function filteredUsers() {
      var _this2 = this;

      if (!this.textFilter) return this.users;
      return this.users.filter(function (user) {
        return user.name.toLowerCase().replace(/ /g, '').indexOf(_this2.textFilter.toLowerCase().replace(/ /g, '')) >= 0 || user.email.toLowerCase().replace(/ /g, '').indexOf(_this2.textFilter.toLowerCase().replace(/ /g, '')) >= 0 || user.department && user.department.toLowerCase().replace(/ /g, '').indexOf(_this2.textFilter.toLowerCase().replace(/ /g, '')) >= 0;
      });
    }
  },
  methods: {
    filterUsers: function filterUsers() {
      if (this.serverSidePagination) {
        this.nextLink = null;
        this.loadUsers().catch(function () {});
      }
    },
    loadUsers: function loadUsers() {
      var _this3 = this;

      var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.showLoading(this.$t('components.inviteUsersFromIntegrationDialog.retrieving_users'));
      var url = "/integrations/".concat(this.provider, "/users?per_page=100").concat(this.nextLink ? '&next_link=' + encodeURIComponent(this.nextLink) : '').concat(this.textFilter ? '&query=' + this.textFilter : '');
      return this.$axios.get(url).then(function (response) {
        var users = response.data.users ? response.data.users : response.data;
        users.map(function (user) {
          user.mode = _this3.provider;
          user.email = user.email || user.userPrincipalName;
          return user;
        });

        if (append) {
          _this3.users = [].concat(_toConsumableArray(_this3.users), _toConsumableArray(users));
        } else {
          _this3.users = users;
        }

        if (response.data.next_link) {
          _this3.nextLink = response.data.next_link;
          _this3.serverSidePagination = true; // this will be set on the first load and stay true for the rest of the time
        } else {
          _this3.nextLink = null;
        }
      }).catch(function (error) {
        // this.selectedProvider.isConfigured = false
        if (error.response.status !== 422) {
          _this3.$q.notify({
            type: 'negative',
            message: _this3.$t('components.inviteUsersFromIntegrationDialog.something_went_wrong_retrieving_users')
          });
        }
      }).finally(function () {
        _this3.hideLoading();
      });
    },
    toggleUserSelected: function toggleUserSelected(user) {
      if (user.isMember || user.isRegistered) return; // Check if the user is already in the selectedUsers array

      var index = this.selectedUsers.findIndex(function (selectedUser) {
        return selectedUser.email === user.email;
      });

      if (index === -1) {
        this.selectedUsers.push(user);
      } else {
        this.selectedUsers.splice(index, 1);
      }
    },
    inviteUsers: function inviteUsers() {
      var _this4 = this;

      this.showLoading();
      User.$inviteUsers(this.selectedUsers.filter(function (user) {
        return user.email;
      })).then(function () {
        Notify.create({
          message: _this4.$t('components.dialogs.users_invited'),
          type: 'positive'
        });
        _this4.selectedUsers = [];

        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'user_invite', {}); // HUBSPOT

          window._hsq.push(['setPath', 'users/invite']);

          window._hsq.push(['trackPageView']);

          if (_this4.$gtag) {
            _this4.$gtag.event('user_invite', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }

        _this4.hideLoading();
      }).catch(function () {
        _this4.hideLoading();
      });
    }
  },
  mounted: function mounted() {
    this.loadUsers();
  }
};